videojs.addLanguage('ru', {
	"Moments settings": "Настройки моментов",
	"Moments": "Моменты",
	"Select moments visible over timeline": "Выберите, какие события отображать на таймлайне",
	"Accept moments settings": "Принять"
});
